import React from "react";
import clsx from "clsx";
import "./group-sticker-message.styles.scss";

import type { IUIGroupStickerMessageContent } from "../../../shared/types";

import { StickerMessage } from "../StickerMessage";
import { useChatBoxViewContext } from "../../../contexts";

export interface GroupStickerMessageProps {
	className?: string;
	content: IUIGroupStickerMessageContent;
}

const BlockName = "group-sticker-message";
const ClassNames = {
	Block: BlockName,
	Modifiers: {
		FromMe: "--from-me",
	},
	Elements: {
		StickerMessage: `${BlockName}__sticker-message`,
	},
} as const;

export type GroupStickerMessageComponent = React.FC<GroupStickerMessageProps> & {
	ClassNames: typeof ClassNames;
};

/**
 * NOTE:
 * Mỗi sticker group message cần play animation cho chính nó hoặc cho từng sticker message bên trong thì...
 * Nó phải tự handle việc setup animation của riêng nó,..
 * Ví dụ như tự nó có FlipTransitionGroup, tự nó có TransitionGroup,...
 * Sau đó, nó muốn đồng bộ với một timeline play send new message của chat box list thì nó sẽ được truyền xuống.
 * Sau đó, nó sẽ request để lấy được cái timeline đó, và request play animtion theo timeline đó.
 */
export const GroupStickerMessage = ((props: GroupStickerMessageProps) => {
	const { content: message } = props;
	const { fromUidInfo } = useChatBoxViewContext();
	const isFromMe = message.fromUid === fromUidInfo.uid;
	return (
		<div
			className={clsx(
				GroupStickerMessage.ClassNames.Block,
				isFromMe && GroupStickerMessage.ClassNames.Modifiers.FromMe,
				props.className,
			)}
		>
			{message.content.map((message) => {
				return (
					<StickerMessage
						key={message.cliMsgId}
						className={GroupStickerMessage.ClassNames.Elements.StickerMessage}
						content={message}
					/>
				);
			})}
		</div>
	);
}) as GroupStickerMessageComponent;
GroupStickerMessage.ClassNames = ClassNames;
